import { Tabs } from 'antd';
import type { TabsProps } from 'antd';
import { useTranslation } from 'react-i18next';

import { AlertRuleType } from '@/api';

import styles from './BehavioralAlertsRuleTypeTabs.module.sass';

interface BehavioralAlertsRuleTypeTabsProps {
  activeTab: AlertRuleType;
  onTabChange: (key: AlertRuleType) => void;
}

export const BehavioralAlertsRuleTypeTabs = ({
  activeTab,
  onTabChange,
}: BehavioralAlertsRuleTypeTabsProps) => {
  const { t } = useTranslation();

  const tabs: TabsProps['items'] = [
    {
      key: AlertRuleType.COMMON,
      label: (
        <span className={styles.tab}>{t('translation.rule_type_common')}</span>
      ),
    },
    {
      key: AlertRuleType.TX_COUNT,
      label: (
        <span className={styles.tab}>
          {t('translation.rule_type_tx_count')}
        </span>
      ),
    },
  ];

  return (
    <Tabs
      defaultActiveKey={tabs[0].key}
      activeKey={activeTab}
      type="card"
      size="middle"
      items={tabs}
      tabBarGutter={0}
      animated={false}
      className={styles.tabs}
      onChange={(key) => onTabChange(key as AlertRuleType)}
    />
  );
};
